import { TEAMS_URLS, getTeamsUrls } from 'api/config';
import $api from 'api/http';
import _ from 'lodash';

export default class TeamsService {
    static async createTeam(data: { companyId: string; title: string }) {
        return $api.post(getTeamsUrls({ reqName: TEAMS_URLS.create_team, ...data }), {
            title: data.title,
        });
    }
    static async teams(companyId: string) {
        return $api.get(getTeamsUrls({ reqName: TEAMS_URLS.teams, companyId }));
    }
    static async team(data: { companyId: string; id: string }) {
        return $api.get(getTeamsUrls({ reqName: TEAMS_URLS.team, ...data }));
    }
    static async teamAgents(data: { companyId: string; id: string }) {
        return $api.get(getTeamsUrls({ reqName: TEAMS_URLS.team_agents, ...data }));
    }
    static async inviteMember(data: { email: string; teamId: string; url: string; companyId: string }) {
        const params = _.omit(data, ['companyId']);
        return $api.post(
            getTeamsUrls({ reqName: TEAMS_URLS.invite_member, id: data.teamId, companyId: data.companyId }),
            params,
        );
    }
    static async removeMember(data: { email: string; teamId: string; url: string; companyId: string }) {
        const params = _.omit(data, ['companyId']);
        return $api.post(getTeamsUrls({ reqName: TEAMS_URLS.remove_member, ...data }), params);
    }
    static async updateTeam(data: { companyId: string; title: string; id: string }) {
        return $api.post(getTeamsUrls({ reqName: TEAMS_URLS.update_team, ...data }), { title: data.title });
    }
    static async deleteTeam(data: { companyId: string; id: string }) {
        console.log('deleteTeam', data);

        return $api.post(getTeamsUrls({ reqName: TEAMS_URLS.delete_team, ...data }));
    }
    static async updateVariables(data: {
        companyId: string;
        teamId: string;
        dialTime: number;
        convoThresh: number;
        textTime: number;
        workDays: number;
    }) {
        const params = _.omit(data, ['companyId']);
        return $api.post(
            getTeamsUrls({ reqName: TEAMS_URLS.update_variables, companyId: data.companyId, id: data.teamId }),
            params,
        );
    }
    static async roles() {
        return $api.post(getTeamsUrls({ reqName: TEAMS_URLS.roles }));
    }
    static async updateRoles() {
        return $api.post(getTeamsUrls({ reqName: TEAMS_URLS.update_roles }));
    }
    static async uploadQuery() {
        return $api.post(getTeamsUrls({ reqName: TEAMS_URLS.upload_query }));
    }
    static async uploadUsers() {
        return $api.post(getTeamsUrls({ reqName: TEAMS_URLS.upload_users }));
    }
    static async uploadLeads() {
        return $api.post(getTeamsUrls({ reqName: TEAMS_URLS.upload_leads }));
    }
    static async timeframe() {
        return $api.post(getTeamsUrls({ reqName: TEAMS_URLS.timeframe }));
    }
    static async summary() {
        return $api.post(getTeamsUrls({ reqName: TEAMS_URLS.summary }));
    }
}
